import { AppHeader } from '@/components/chat/AppHeader';
import { ChatDrawer } from '@/components/chat/ChatDrawer';
import { ChatLayoutProvider } from '@/components/context/ChatLayoutContext';
import { ChatUIContextProvider } from '@/components/context/ChatUIContext';
import { client as gqlClient } from '@/api/GraphQLClient';
import { PageLevelError, ScrollToTopOnPageChange } from '@/components/shared';
import { SpansProvider } from '@/components/context/SpansContext';
import { useInitUserAndThreads } from '@/hooks/initUserAndThreads';

import { ApolloProvider } from '@apollo/client';
import { Outlet } from 'react-router-dom';
import { SpriteProvider } from '@allenai/varnish-ui';
import styled from 'styled-components';

export const MainPage = () => {
  const varnishUiSprite = require('@allenai/varnish-ui/varnish-ui-sprite.svg');
  useInitUserAndThreads();

  return (
    <div>
      <ApolloProvider client={gqlClient}>
        <SpansProvider>
          <ChatUIContextProvider>
            <ChatLayoutProvider>
              <SpriteProvider sprite={varnishUiSprite.default}>
                <ChatContainer>
                  <PageLayout>
                    <PageLayoutDrawer>
                      <ChatDrawer />
                    </PageLayoutDrawer>
                    <PageLayoutContent>
                      <AppHeader />
                      <Outlet />
                    </PageLayoutContent>
                  </PageLayout>
                  <PageLevelError />
                </ChatContainer>
              </SpriteProvider>
            </ChatLayoutProvider>
          </ChatUIContextProvider>
        </SpansProvider>
      </ApolloProvider>
      <ScrollToTopOnPageChange />
    </div>
  );
};

const ChatContainer = styled('div')`
  background-color: #032629; // TODO: replace once varnish updates dark-blue-100 in theme
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;

  & > * {
    flex: 1 1 auto;
  }
`;

const PageLayout = styled('div')`
  display: grid;
  grid-template-areas: 'chat-drawer page-content';
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr;
`;

const PageLayoutDrawer = styled('div')`
  grid-area: chat-drawer;
`;

const PageLayoutContent = styled('div')`
  display: grid;
  grid-area: page-content;
  grid-template-rows: auto 1fr;
`;
